import RequestForm from "@/pages/contact/RequestForm";
import { VOLUNTEER_FORM } from "@/pages/contact/requestFormsContent";

export default function VolunteerRequest() {
  return <RequestForm spec={VOLUNTEER_FORM} />;
}
